import { render, staticRenderFns } from "./Tank.vue?vue&type=template&id=e4b47d4e&scoped=true&"
import script from "./Tank.vue?vue&type=script&lang=js&"
export * from "./Tank.vue?vue&type=script&lang=js&"
import style0 from "./Tank.vue?vue&type=style&index=0&id=e4b47d4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b47d4e",
  null
  
)

export default component.exports